var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"batteryChart"}),(_vm.debug)?_c('v-card',[_c('v-card-title',[_vm._v("Debug Information")]),_c('v-card-text',[_vm._v(" UnitID: "+_vm._s(_vm.UnitID)+" "),_c('br'),_vm._v(" Time: "+_vm._s(_vm.startTime)+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }